<script>
import Layout from '../../layouts/main'
import PageHeader from "@/components/page-header";
import { GridComponent, ColumnsDirective, ColumnDirective,
  Page, Toolbar, Sort, Filter, Resize, PdfExport, ExcelExport } from '@syncfusion/ej2-vue-grids';
import api from "@/axios";
import Loader from "@/router/views_mobagile/components/loader.vue";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  components: {
    Loader, Layout, PageHeader,
    'ejs-grid': GridComponent,
    'e-columns': ColumnsDirective,
    'e-column': ColumnDirective,
  },
  data() {

    return {
      title: "Veículos",
      items: [
        {
          text: "Transporte",
          href: "/"
        },
        {
          text: "Veículos",
          active: true
        }
      ],
      dataList: null,
      loading: true,

      filterSettings: { type: 'Excel' },
      toolbar: [
        { text: 'Criar Veículo', prefixIcon: 'e-text-wrap', id: 'criarVeiculo', align: 'Left', disabled: false },
        { text: 'Abrir Financeiro', prefixIcon: 'e-group-2', id: 'abrirFinanceiro', align: 'Left', disabled: true },
        { tooltipText: 'Exportar Excel', prefixIcon: 'e-export-excel', id: 'exportExcel', align: 'Left' },
        { tooltipText: 'Exportar CSV', prefixIcon: 'e-export-csv', id: 'exportCsv', align: 'Left' },
        { text: 'Search', tooltipText: 'Pesquisar'}
      ],
      pageSets: {
        pageSize: 5,
        currentPage: 1,
        totalRecordsCount: 0,
        pageSizes: ['20', '100', '200']
      },

    }
  },

  created() {

  },

  mounted() {
    console.log('mounted veiculo-list_0')
    this.atualizaDataList()
  },

  provide: {
    grid: [Page, Toolbar, Sort, Filter, Resize, PdfExport, ExcelExport]
  },

  methods: {

    tbClickHandler: function(args) {
      console.log('tbClickHandler')
      console.log(args.item.id)

      if (args.item.id === 'exportExcel') {
        this.loading = true
        const fileProps = {
          fileName: 'veiculos.xlsx'
        }
        this.$refs.dataGridAts.excelExport(fileProps)
        this.loading = false
      }
      else if (args.item.text === 'exportCsv') {
        this.loading = true
        const fileProps = {
          fileName: 'veiculos.csv'
        }
        this.$refs.dataGridAts.csvExport(fileProps)
        this.loading = false
      } else if (args.item.id === 'criarVeiculo') {
        const routeData = this.$router.resolve(`/veiculo/editar/0`)
        window.open(routeData.href, '_blank')
      }
    },

    recDblClick(evt){
      console.log('recDblClick')
      console.log(evt)
      this.$router.push('/veiculo/editar/' + evt.rowData.id)
    },

    recPedDblClick(evt){
      console.log('recPedDblClick')
      console.log(evt)
      // this.pedidoData = evt.rowData
      // this.showModalPedido = true
    },

    atualizaDataList(page, pageSize, search){
      console.log('atualizaDataList')
      this.loading = true
      const paramsReq = {
        'page': page,
        'pageSize': pageSize,
        'search': search
      }
      api.get(`${getBaseUrl()}api/veiculos`, {
        params: paramsReq
      }).then(response => {
        console.log('response.bases')
        console.log(response.data[0])
        this.dataList = {
          result: response.data[0],
          count: response.data[1],
        }
        this.pageSets.totalRecordsCount = response.data[1]
        this.pageSets.currentPage = page
        this.pageSets.pageSize = pageSize
        this.title = `(${this.pageSets.totalRecordsCount}) Veículos`
        this.loading = false
      })
    },

    changePage(args){
      console.log('changePage')
      // console.log(args)
      if (args.currentPage || args.searchString){
        console.log(args)
        this.atualizaDataList(args.currentPage, args.pageSize, args.searchString ?? null)
      }
    },

    dataBound: function() {
      this.$refs.dataGrid.autoFitColumns([])
    },

    formatDecimal(value) {
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

  },
};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>

    <div class="card">
      <div class="card-body">

        <Loader v-if="loading">
        </Loader>
        <div v-if="!loading">
          <ejs-grid :dataSource="dataList"
                    ref="dataGrid"
                    :actionBegin="changePage"
                    :allowFiltering="false"
                    :allowPdfExport="true"
                    :allowExcelExport="true"
                    :allowPaging="true"
                    :enableColumnVirtualization="true"
                    :recordDoubleClick="recDblClick"
                    :dataBound="dataBound"
                    :pageSettings="pageSets"
                    :toolbar="toolbar"
                    :toolbarClick="tbClickHandler"
                    :selectionSettings="{ mode: 'Row', type: 'Multiple' }"
                    :scrollSettings="{enableColumnScrolling: true, enableRowScrolling: true}">
            <e-columns>
              <e-column field="id" headerText="ID" textAlign="Left"></e-column>
              <e-column field="marca" headerText="Marca" textAlign="Left"></e-column>
              <e-column field="modelo" headerText="Modelo" textAlign="Left"></e-column>
              <e-column field="placa" headerText="Placa" textAlign="Left" width="auto"></e-column>
              <e-column field="ano" headerText="Ano" textAlign="Left"></e-column>
              <e-column field="tipo" headerText="Tipo" textAlign="Left"></e-column>
              <e-column field="cor" headerText="Cor" textAlign="Left"></e-column>
              <e-column field="capackg" headerText="Capacidade Kg" textAlign="Right"></e-column>
              <e-column field="capacmcubic" headerText="Capacidade M³" textAlign="Right"></e-column>

            </e-columns>
          </ejs-grid>
        </div>

      </div>
    </div>

  </Layout>
</template>

